<template>
  <div>
    <Banner value="Galeria de Fotos"/>
    <div>
      <iframe
        name="interno"
        width="100%"
        height="1000"
        src="http://escola-engenho.synology.me:81/photo/#!Albums"
      ></iframe>
    </div>
  </div>
</template>

<script>
// http://escola-engenho.synology.me:81/photo

import Banner from "../components/Banner";

export default {
  data: () => ({}),
  components: {
    Banner
  }
};
</script>

<style lang="scss">
p {
  text-align: center;
  font-weight: bold;
}
</style>
